import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { Button, ButtonProps, Stack } from '@optimus-web/core';
import { PrimaryActionProps } from '../../common';
import { StepProps } from '../types';

export type SteppedPrimaryActionsProps<S extends string> = PrimaryActionProps &
    StepProps<S> & { saveLabel?: ReactNode; submitButtonDataTestId?: string; nextStepButtonDataTestId?: string };

export const SteppedPrimaryActions = <S extends string>({
    currentStep,
    handleSubmit,
    id,
    nextStepButtonDataTestId,
    saveLabel = lt('Save'),
    setCurrentStep,
    steps,
    submitButtonDataTestId,
    ...buttonProps
}: SteppedPrimaryActionsProps<S> & Omit<ButtonProps, 'variant' | 'form' | 'onClick' | 'type'>) => {
    const currentStepIndex = steps.indexOf(currentStep);
    return (
        <Stack spacing="150">
            {currentStep === steps[0] ? null : (
                <Button
                    type="button"
                    variant="secondary"
                    onClick={() => {
                        setCurrentStep(steps[currentStepIndex - 1]);
                    }}
                >
                    {lt('GoBack')}
                </Button>
            )}
            <Button
                variant="primary"
                form={id}
                onClick={handleSubmit}
                data-test-id={currentStep === steps.at(-1) ? submitButtonDataTestId : nextStepButtonDataTestId}
                {...buttonProps}
                type="submit"
            >
                {currentStep === steps[steps.length - 1] ? saveLabel : lt('Next')}
            </Button>
        </Stack>
    );
};
